export default __webpack_public_path__ + "static/media/64-min.b5f685fd.png";